import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useInfrastructureChartsDataContext } from './hooks/useInfrastructureChartsDataContext';

export const HouseSideWalk = () => {
    const { chartData } = useInfrastructureChartsDataContext();


    return (
        <SimpleBars
            title={'Calçada em Frente ao Domicílio'}
            horizontal={true}
            subtitles={chartData?.houseSideWalk?.map((item) => item.description)}
            values={chartData?.houseSideWalk?.map((item) => item.total  ||  0)}
        />
    );
};
